// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"5b6a1f40","157":"5b6a1f40","302":"5b6a1f40","649":"5b6a1f40","926":"5b6a1f40"}[chunkId] + ".chunk.css";
};